import { useState } from "react";
import css from "./Gallery.module.css";
import Image from "./Image";

const Gallery = ({ pictures, showAll: _showAll = false }) => {
  const [showAll, setShowAll] = useState(_showAll);

  const pics = showAll ? pictures : pictures.slice(0, 3);

  const display = pics.map((img, index) => <Image key={index} img={img} />);

  let button;

  if (!showAll && pictures.length > 3) {
    button = (
      <button onClick={() => setShowAll(true)} className="link">
        SEE MORE
      </button>
    );
  }

  return (
    <div className={css.main}>
      <div className="columns_3">{display}</div>
      {button}
    </div>
  );
};

export default Gallery;
